import { useEffect, useState } from "react";
import SelectOption from "../../../../../../common/components/form/select/common/option/select-option";
import userTranslationsHelper from "../../../../../../languages/user-translations.helper";
import SingleSelectComponent from "../../../../../../common/components/form/select/single-select/single-select.component";
import taxiContractFactory from "./taxi-contract.factory";
import SelectOptionTaxiContractComponent from "./types/select-taxi-taxi-contracts";
import useAbort from "../../../../../../common/hooks/use-abort";
import useContractsTaxiForwardingContract from "../../../../../../common/services/contracts/taxi-forwarding/contract/use-contracts-taxi-forwarding-contract";
import ContractsTaxiForwardingContractParams from "../../../../../../common/services/contracts/taxi-forwarding/contract/contracts-taxi-forwarding-contract-params";

type OrderDetailsSelectTaxiContractsComponentProps = {
  taxiCorporationUuid: string;
  isEditEnable?: boolean;
  selectedTaxiContract?: SelectOption | null;
  producerTaxiId: string | null;
  onChange: (value: SelectOption) => void;
};

const OrderDetailsSelectTaxiContractsComponent = (
  props: OrderDetailsSelectTaxiContractsComponentProps,
) => {
  const [taxiContractSelectOptions, setTaxiContractSelectOptions] = useState<
    SelectOptionTaxiContractComponent[]
  >([]);
  const translations =
    userTranslationsHelper.getTaxiOfficerListingTranslations().select;

  const contractsTaxiForwardingContract = useContractsTaxiForwardingContract();
  const contractsTaxiForwardingContractAbort = useAbort();

  const loadContractsTaxiForwarding = (
    selectedTaxiCorporationId: string,
    producerId: string | null,
  ) => {
    const loadParams: ContractsTaxiForwardingContractParams = {
      producerId: producerId!,
      selectedTaxiCorporationId: selectedTaxiCorporationId,
    };

    contractsTaxiForwardingContract.load(
      loadParams,
      contractsTaxiForwardingContractAbort.signal,
    );
  };

  useEffect(() => {
    if (!props.producerTaxiId || !props.taxiCorporationUuid) {
      return;
    }

    loadContractsTaxiForwarding(
      props.taxiCorporationUuid,
      props.producerTaxiId,
    );

    return contractsTaxiForwardingContractAbort.revoke;
  }, [props.taxiCorporationUuid!, props.producerTaxiId]);

  useEffect(() => {
    const taxiCorporationsSelectOptions =
      taxiContractFactory.createTaxiContractsSelectOptions(
        contractsTaxiForwardingContract.data.data,
      );
    setTaxiContractSelectOptions(taxiCorporationsSelectOptions);
  }, [contractsTaxiForwardingContract.data]);

  return (
    <SingleSelectComponent
      placeholder={translations.selectTaxiCorporationPlaceholder}
      value={props.selectedTaxiContract!}
      onChange={(value) => props.onChange(value!)}
      options={taxiContractSelectOptions}
      isLoading={contractsTaxiForwardingContract.isLoading}
      isDisabled={props.isEditEnable}
      isSearchable
      menuPlacement="bottom"
      menuPosition="fixed"
    />
  );
};

export default OrderDetailsSelectTaxiContractsComponent;
